<template>
  <div class="flex flex-wrap">
    <div class="w-full mt-12 mb-12 px-4">
      <div
        class="relative pb-6 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded"
        :class="[color === 'light' ? 'bg-white' : 'bg-emerald-900 text-white']"
      >
        <div
          class="rounded-t mb-0 px-4 py-3 border-0 border-b-4 border-solid"
          :class="
            getRegion === 'au'
              ? 'border-green-200 bg-green-100'
              : getRegion === 'nz'
              ? 'border-gray-400 bg-gray-200'
              : 'border-blue-300 bg-blue-200'
          "
        >
          <div class="text-center flex justify-between items-center">
            <h3
              class="font-semibold text-lg px-4 py-3"
              :class="[color === 'light' ? 'text-blueGray-700' : 'text-white']"
            >
              COMPONENT TABLE
            </h3>
          </div>
        </div>
        <div class="block w-full overflow-x-auto">
          <table class="items-center w-full bg-transparent border-collapse">
            <TableHead :headers="['ID', 'Name', 'Description']" />
            <tbody>
              <TableRow
                v-for="(data, index) in getAllComponent.filter(
                  (item) => item.name !== 'abi_category' && item.be_used === '1'
                )"
                :key="index"
                :data="data"
                :id="index"
              />
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TableHead from "@/components/DashboardModule/TableHead";
import TableRow from "@/components/DashboardModule/TableRow";

export default {
  name: "Dashboard",
  components: {
    TableHead,
    TableRow
  },
  data() {
    return {};
  },
  props: {
    color: {
      default: "light",
      validator(value) {
        // The value must match one of these strings
        return ["light", "dark"].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    ...mapGetters(["getAllComponent", "getRegion"])
  }
};
</script>
